import { Injectable, inject } from '@angular/core';
import { AppConfig } from '@boels/models';
import { DOCUMENT } from '@angular/common';
import { WindowRef } from '@boels/helpers';

@Injectable()
export class NewrelicMonitoringService {
  #document = inject<Document>(DOCUMENT);
  #winref = inject(WindowRef);
  #environment = inject<AppConfig>('ENVIRONMENT' as any);

  init(): void {
    if (!this.#winref.isBrowser()) return;

    if (this.#environment.name === 'prod') {
      const scriptEl = this.#document.createElement('script');
      scriptEl.defer = true;
      scriptEl.src = 'assets/scripts/monitoring-script.js';
      this.#document.head.appendChild(scriptEl);
    }
  }
}
